import { gql } from '@apollo/client';

export const CREATE_REPORT_FILES = gql`
  mutation createReportFiles($inputs: [CreateFileInput!]!) {
    createReportFiles: createFiles(inputs: $inputs) {
      id
    }
  }
`;
